import { FC } from "react";
import settings from "/svg/settings.svg";
import reactions from "/svg/favourite.svg";
import { Link, useLocation } from "react-router-dom";
import { ThemeToggle } from "@features/theme";
import { AppRoutes } from "@shared/constants";

import styles from "./Header.module.scss";

export const Header: FC = () => {
  const location = useLocation();

  return (
    <div className={styles.header}>
      {location.pathname === AppRoutes.MATCH ? (
        <Link to="/settings">
          <img src={settings} className={styles.headerIcon} />
        </Link>
      ) : (
        <ThemeToggle />
      )}
      <Link to="/reactions">
        <img src={reactions} className={styles.headerIcon} />
      </Link>
    </div>
  );
};
